import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiCalendar } from "react-icons/fi";
import { motion, useMotionValue, useMotionTemplate } from "framer-motion";
import HeroImg from "../Images/hero-img.webp";

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.15,
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 50,
    filter: "blur(12px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const Hero = () => {
const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  function handleMouseMove({ currentTarget, clientX, clientY }) {
    const { left, top } = currentTarget.getBoundingClientRect();
    mouseX.set(clientX - left);
    mouseY.set(clientY - top);
  }

  // Interactive radial mask that follows cursor
  const spotlightMask = useMotionTemplate`radial-gradient(380px circle at ${mouseX}px ${mouseY}px, rgba(15, 174, 77, 0.15), transparent 80%)`;

const [ray, setRay] = useState({
  type: "horizontal",
  position: 60,
  key: 0,
});

useEffect(() => {
  const changeRay = () => {
    const type = Math.random() > 0.5 ? "horizontal" : "vertical";

    const gridSize = 60;

    // Grid is 480px high
    const horizontalPositions = [];

    for (let i = 0; i <= 480; i += gridSize) {
      horizontalPositions.push(i);
    }

    // Use viewport width for vertical grid lines
    const verticalPositions = [];

    for (let i = 0; i <= window.innerWidth; i += gridSize) {
      verticalPositions.push(i);
    }

    const position =
      type === "horizontal"
        ? horizontalPositions[
            Math.floor(Math.random() * horizontalPositions.length)
          ]
        : verticalPositions[
            Math.floor(Math.random() * verticalPositions.length)
          ];

    setRay({
      type,
      position,
      key: Date.now(),
    });
  };

  changeRay();

  const interval = setInterval(changeRay, 5000);

  return () => clearInterval(interval);
}, []);
  return (
    <section className="hero" onMouseMove={handleMouseMove}>

      {/* SaaS Background */}
      {/* SaaS Background */}
<div className="hero-background">

  {/* Static Grid */}
  <div className="hero-grid" />

  <motion.div
          className="grid-spotlight"
          style={{ background: spotlightMask }}
        />

 <div
  key={ray.key}
  className={`hero-ray ${
    ray.type === "horizontal"
      ? "horizontal-ray"
      : "vertical-ray"
  }`}
  style={
    ray.type === "horizontal"
      ? {
          top: `${ray.position}px`,
        }
      : {
          left: `${ray.position}px`,
        }
  }
/>

</div>

      <div className="container">

        <motion.div
          className="hero-content"
          variants={container}
          initial="hidden"
          animate="visible"
        >

          <motion.h1 variants={fadeUp}>
            Turn every conversation
            <br />
            into a business <span>opportunity.</span>
          </motion.h1>

          <motion.p
            className="section-text"
            variants={fadeUp}
          >
            Build stronger customer relationships, automate engagement,
            manage conversations at scale, and convert every interaction
            into measurable business growth and higher customer satisfaction.
          </motion.p>

          <motion.div
            className="hero-btns"
            variants={fadeUp}
          >

            <motion.div
              whileHover={{
                y: -5,
                scale: 1.04,
              }}
              whileTap={{
                scale: 0.97,
              }}
              transition={{
                type: "spring",
                stiffness: 350,
                damping: 18,
              }}
            >
              <Link
                to="/book-a-demo"
                className="btn btn-demo"
              >
                <motion.span
                  animate={{
                    rotate: [0, -10, 10, 0],
                  }}
                  transition={{
                    repeat: Infinity,
                    repeatDelay: 5,
                    duration: 0.8,
                  }}
                >
                  <FiCalendar />
                </motion.span>

                <span>Book a Demo</span>
              </Link>
            </motion.div>


            <motion.div
              whileHover={{
                y: -5,
                scale: 1.04,
              }}
              whileTap={{
                scale: 0.97,
              }}
              transition={{
                type: "spring",
                stiffness: 350,
                damping: 18,
              }}
            >
              <a
                href="https://app.onbbits.io/register"
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary"
              >
                Get Started For Free
              </a>
            </motion.div>

          </motion.div>


          <motion.div
            className="hero-image"
            initial={{
              opacity: 0,
              y: 120,
              scale: 0.9,
              rotateX: 18,
              filter: "blur(14px)",
            }}
            animate={{
              opacity: 1,
              y: 0,
              scale: 1,
              rotateX: 0,
              filter: "blur(0px)",
            }}
            transition={{
              delay: 0.75,
              duration: 1.2,
              ease: [0.22, 1, 0.36, 1],
            }}
            whileHover={{
              y: -10,
              transition: {
                duration: 0.4,
              },
            }}
          >

            <motion.img
              src={HeroImg}
              alt="Turn every conversation into a business opportunity | Onbbits"
              animate={{
                y: [0, -10, 0],
              }}
              transition={{
                duration: 6,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />

          </motion.div>

        </motion.div>

      </div>

    </section>
  );
};
export default Hero